<app-header></app-header>
<ion-content [scrollY]="false">
  <div #mainDivScroll class="invoices-content gray-content-bg">
    <ng-container
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
    >
      <app-page-title-banner
        *ngIf="paymentsPageVM$ | async; let vm"
        [pageTitle]="(vm?.canPayInvoice ? 'i18n.payments.title' :'i18n.payments.titleNoPaymentFlag')|translate"
        [backgroundImageStyle]="backgroundImageStyle"
        [overlayGradient]="overlayGradient"
        [showEllipsis]="false"
      >
      </app-page-title-banner>
    </ng-container>

    <ng-container *ngIf="paymentsPageVM$ | async; let vm">
      <div class="dashboard-selector" *ngIf="vm.isDashboardOn">
        <app-dashboard-selector
          [dashboardTabs]="vm.dashboardTabs"
        ></app-dashboard-selector>
      </div>
    </ng-container>

    <div class="payments-content" *ngIf="paymentsPageVM$ | async; let vm">
      <ion-grid>
        <ion-row>
          <ion-col
            [size]="platformService.platformType === 'mobile' ? 12 : 6"
            class="account-balance-col"
          >
            <app-account-balance
              [accountSummaryState]="vm?.accountSummaryState"
              [enablePayBalanceButton]="(vm?.canPayInvoice && !showMakePayments) || (vm?.canPayInvoice && showMakePayments)"
              [showMakePayments]="showMakePayments"
              [platformEnum]="this.platformService.platformType"
              [isTouch]="platformService.isTouch.value"
              [customers]="vm?.customers"
              [selectedCustomer]="vm?.selectedCustomer"
              [showAllCustomersOption]="vm?.showAllCustomersOption"
              (customerSwitchEmitter)="onCustomerSwitch($event)"
              (allInvoicesClickEmitter)="goToAllInvoices(true)"
              (payAccountBalanceClickEmitter)="goToPayAccountBalance()"
              [isSuperUser]="vm.isSuperUser"
            >
            </app-account-balance>
          </ion-col>
          <!-- Tiles -->
          <ion-col
            *ngIf="this.platformService.platformType !== this.platformService.platformEnum.mobile"
            size="6"
          >
            <ion-row>
              <ion-col
                [size]="vm?.canPayInvoice && showMakePayments ? '6' : '12'"
                [ngClass]="{'column-tile-tablet' : this.platformService.platformType === this.platformService.platformEnum.tablet}"
              >
                <app-payment-tile-desktop-tablet
                  [platformEnum]="invoicesTile?.platformEnum"
                  [isTouch]="invoicesTile?.isTouch"
                  [title]="isARStatementsEnabled ? invoicesAndStatementsTile?.title : invoicesTile?.title"
                  [badgeText]="isARStatementsEnabled && isARStatementsNewBadgeEnabled ? invoicesAndStatementsTile?.badgeText : undefined"
                  [badgeColor]="isARStatementsEnabled && isARStatementsNewBadgeEnabled ? 'primary' : undefined"
                  [textBody]="isARStatementsEnabled ? invoicesAndStatementsTile?.textBody : invoicesTile?.textBody"
                  [textButton]="this.platformService.platformType === 'desktop' ? invoicesAndStatementsTile?.textButton : ''"
                  (actionClickEmitter)="goToAllInvoices()"
                ></app-payment-tile-desktop-tablet>
              </ion-col>
              <ion-col
                size="6"
                *ngIf="vm?.canPayInvoice && showMakePayments"
                [ngClass]="{'column-tile-tablet' : this.platformService.platformType === this.platformService.platformEnum.tablet}"
              >
                <app-payment-tile-desktop-tablet
                  [platformEnum]="makePaymentTile?.platformEnum"
                  [isTouch]="makePaymentTile?.isTouch"
                  [title]="makePaymentTile?.title"
                  [textBody]="makePaymentTile?.textBody"
                  [textButton]="this.platformService.platformType === 'desktop' ? makePaymentTile?.textButton : ''"
                  [badgeText]="makePaymentTile?.badgeText"
                  [badgeColor]="'warning'"
                  (actionClickEmitter)="goToMakeAPayment()"
                ></app-payment-tile-desktop-tablet>
              </ion-col>
            </ion-row>
            <ion-row>
              <ng-container
                *ngIf="isPaymentActivityEnabled || (vm?.canPayInvoice && isPaymentPreferencesEnabled); else elseBlock"
              >
                <ion-col
                  [size]="vm?.canPayInvoice && isPaymentPreferencesEnabled ? '6' : '12'"
                  [ngClass]="{'column-tile-tablet' : this.platformService.platformType === this.platformService.platformEnum.tablet}"
                  *ngIf="isPaymentActivityEnabled"
                >
                  <app-payment-tile-desktop-tablet
                    [platformEnum]="paymentActivityTile?.platformEnum"
                    [isTouch]="paymentActivityTile?.isTouch"
                    [title]="paymentActivityTile?.title"
                    [textBody]="paymentActivityTile?.textBody"
                    [textButton]="platformService.platformType === platformService.platformEnum.tablet ? '' : paymentActivityTile?.textButton"
                    [iconButton]="platformService.platformType === platformService.platformEnum.tablet ?  '' : paymentActivityTile?.iconButton"
                    (actionClickEmitter)="goToPaymentActivity()"
                  ></app-payment-tile-desktop-tablet>
                </ion-col>
                <ion-col
                  [size]="isPaymentActivityEnabled ? '6' : '12'"
                  [ngClass]="{'column-tile-tablet' : this.platformService.platformType === this.platformService.platformEnum.tablet}"
                  *ngIf="isPaymentPreferencesEnabled && vm?.canPayInvoice"
                >
                  <app-payment-tile-desktop-tablet
                    [platformEnum]="paymentPreferencesTile?.platformEnum"
                    [isTouch]="paymentPreferencesTile?.isTouch"
                    [title]="paymentPreferencesTile?.title"
                    [textBody]="paymentPreferencesTile?.textBody"
                    [textButton]="platformService.platformType === platformService.platformEnum.tablet ? '' : paymentActivityTile?.textButton"
                    [iconButton]="platformService.platformType === platformService.platformEnum.tablet ?  '' : paymentActivityTile?.iconButton"
                    (actionClickEmitter)="goToPaymentPreferences()"
                    [shouldCenterTitle]="true"
                  ></app-payment-tile-desktop-tablet>
                </ion-col>
              </ng-container>
              <ng-template #elseBlock>
                <ion-col
                  size="12"
                  [ngClass]="this.platformService.platformType === this.platformService.platformEnum.tablet ? 'column-tile-tablet' : ''"
                >
                  <app-payment-tile-desktop-tablet
                    [platformEnum]="comingSoonTile?.platformEnum"
                    [isTouch]="comingSoonTile?.isTouch"
                    [title]="comingSoonTile?.title"
                    [textBody]="showMakePayments ? comingSoonPaymentTile?.textBody : comingSoonTile?.textBody"
                    [textButton]="vm.isSuperUser ? '':(showMakePayments ? comingSoonPaymentTile?.textButton : comingSoonTile?.textButton)"
                    [iconButton]="comingSoonTile?.iconButton"
                    (actionClickEmitter)="goToLegacyPlatform(vm.isSuperUser)"
                  ></app-payment-tile-desktop-tablet>
                </ion-col>
              </ng-template>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
      <ion-list
        *ngIf="this.platformService.platformType === this.platformService.platformEnum.mobile"
        lines="none"
      >
        <app-payment-tile-mobile
          [title]="isARStatementsEnabled ? invoicesAndStatementsTile?.title : invoicesAndStatementsTile?.title"
          (actionClickEmitter)="goToAllInvoices()"
        ></app-payment-tile-mobile>
        <app-payment-tile-mobile
          *ngIf="vm?.canPayInvoice && showMakePayments"
          [title]="makePaymentTile?.title"
          [badgeText]="makePaymentTile?.badgeText"
          (actionClickEmitter)="goToMakeAPayment()"
        ></app-payment-tile-mobile>
        <app-payment-tile-mobile
          *ngIf="isPaymentActivityEnabled"
          [title]="paymentActivityTile?.title"
          (actionClickEmitter)="goToPaymentActivity()"
        ></app-payment-tile-mobile>
        <app-payment-tile-mobile
          *ngIf="isPaymentPreferencesEnabled && vm?.canPayInvoice"
          [title]="paymentPreferencesTile?.title"
          (actionClickEmitter)="goToPaymentPreferences()"
        ></app-payment-tile-mobile>
      </ion-list>
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <ng-container
              *ngIf="isPaymentActivityEnabled && vm.showAutopayBanner; else elseBlock"
            >
              <app-autopay-banner
                *ngIf="!vm.isSuperUser && vm?.canPayInvoice"
                [isAutopayEnabled]="vm.isAutopayOn"
                [platformType]="this.platformService.platformType"
                (buttonClickEmitter)="goToPaymentPreferences(true)"
              ></app-autopay-banner>
            </ng-container>
            <ng-template #elseBlock>
              <app-payment-tile-desktop-tablet
                *ngIf="this.platformService.platformType === this.platformService.platformEnum.mobile"
                [platformEnum]="showMakePayments ? comingSoonPaymentTile?.platformEnum : comingSoonTile?.platformEnum"
                [isTouch]="showMakePayments ? comingSoonPaymentTile?.isTouch : comingSoonTile?.isTouch"
                [title]="showMakePayments ? comingSoonPaymentTile?.title : comingSoonTile?.title"
                [textBody]="showMakePayments ? comingSoonPaymentTile?.textBody : comingSoonTile?.textBody"
                [textButton]="vm.isSuperUser ? '':(showMakePayments ? comingSoonPaymentTile?.textButton : comingSoonTile?.textButton)"
                [iconButton]="showMakePayments ? comingSoonPaymentTile?.iconButton : comingSoonTile?.iconButton"
                (actionClickEmitter)="goToLegacyPlatform(vm.isSuperUser)"
              >
              </app-payment-tile-desktop-tablet>
            </ng-template>
          </ion-col>
        </ion-row>
      </ion-grid>
      <app-recent-invoices-credits-desktop
        *ngIf="platformService.platformType === platformService.platformEnum.desktop; else TouchDevices"
        [recentInvoices]="vm.invoices || []"
        [recentCredits]="vm.credits || []"
        [isTouch]="makePaymentTile?.isTouch"
        [browserDimensions]="platformService.getBrowserDimensions()"
        [translatorText]="recentInvoicesAndCreditsText"
        [transactionRowText]="transactionRowText"
        [showOrderNumber]="showOrderNumber"
        [isLoadingCredits]="vm.isLoadingCredits"
        [isLoadingInvoices]="vm.isLoadingInvoices"
        [paymentsEnabled]="vm.canPayInvoice && showMakePayments"
        (allInvoicesClickEmitter)="goToAllInvoices()"
        (invoicesAndCreditsOptionsEmitter)="openMobileInvoicesCreditsOptions($event)"
        (viewInvoiceClickEmitter)="viewInvoice($event)"
        (payInvoiceClickEmitter)="payInvoice($event)"
      ></app-recent-invoices-credits-desktop>

      <ng-template #TouchDevices>
        <app-recent-invoices-credits-touch
          [recentInvoices]="vm.invoices || []"
          [recentCredits]="vm.credits || []"
          [isMobile]="platformService.platformType === platformService.platformEnum.mobile"
          [translatorText]="recentInvoicesAndCreditsText"
          [transactionRowText]="transactionRowText"
          [showOrderNumber]="showOrderNumber"
          [paymentsEnabled]="vm.canPayInvoice && showMakePayments"
          (allInvoicesClickEmitter)="goToAllInvoices()"
          (invoicesAndCreditsOptionsEmitter)="openMobileInvoicesCreditsOptions($event)"
          (viewInvoiceClickEmitter)="viewInvoice($event)"
        ></app-recent-invoices-credits-touch>
      </ng-template>
    </div>

    <app-footer></app-footer>
  </div>
</ion-content>

<div class="top-button-action">
  <ion-button
    class="usf-outline-green-button"
    (click)="goToAllInvoices()"
    data-cy="go-to-all-invoices-btn"
  >
    {{ 'i18n.payments.recentInvoicesCredits.seeAllInvAndCred' | translate }}
  </ion-button>

  <app-top-button
    [mainScroll]="mainScroll"
    [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
  ></app-top-button>
</div>
